import { css, html, LitElement, PropertyValues, unsafeCSS } from "lit";
import { customElement } from "lit/decorators/custom-element.js";
import { Store } from "../../state/store";
import { Controller } from "../../state/controller";
import { sharedStyles } from "../../styles/shared";
import { addRouteChangedListener, removeRouteChangedListener } from "../../util/route-util";
import { EMOJI_FONT_NAME, ROUTES, SUPPORT_EMAIL } from "../../config";
import { themeStore } from "../../state/theme/theme-store";
import { setColorMode } from "../../state/theme/theme-action";
import "../../atoms/switch";
import { classMap } from "lit/directives/class-map.js";

function getCurrentYear() {
	return new Date().getFullYear();
}

class LandingFooterStore extends Store {
	model$ = {
		colorMode: themeStore.model$.colorMode
	};
}

@customElement("bs-landing-footer")
export class BsLandingFooter extends LitElement {
	static get styles() {
		return [
			sharedStyles,
			css`
				:host {
					display: flex;
					align-items: center;
					justify-content: space-between;
					background: var(--shade-light);
					color: var(--shade-contrast-light);
					width: 100%;
					padding: var(--space-xl);
				}

				.active {
					cursor: default;
					font-weight: 800;
				}

				.color-mode-emoji {
					font-family: "${unsafeCSS(EMOJI_FONT_NAME)}";
					filter: grayscale(100%);
					opacity: 0.5;
					transition: transform 120ms ease-out, opacity 120ms ease-out;
					transform: scale(0.9) rotate(10deg);
				}

				.color-mode-emoji.active {
					filter: unset;
					opacity: 1;
					transform: scale(1) rotate(0deg);
				}

				@media (max-width: 800px) {
					:host {
						flex-direction: column;
						gap: var(--space-s);
					}
				}
			`
		];
	}

	protected controller = new Controller(this, new LandingFooterStore());
	protected boundRouteChanged = this.routeChanged.bind(this);

	protected firstUpdated(props: PropertyValues) {
		super.firstUpdated(props);
		addRouteChangedListener(this.boundRouteChanged);
	}

	disconnectedCallback() {
		super.disconnectedCallback();
		removeRouteChangedListener(this.boundRouteChanged);
	}

	routeChanged() {
		this.requestUpdate();
	}

	render() {
		const { colorMode } = this.controller.model;
		return html`
			<div>© ${getCurrentYear()} Ideamap. All rights reserved.</div>
			<div>
				<bs-form-item invert flat>
					<button slot="input" @click="${() => window.open(ROUTES.legal, "_blank")}">Legal</button>
				</bs-form-item>
				<bs-form-item invert flat>
					<button slot="input" @click="${() => window.open(`mailto:${SUPPORT_EMAIL}`, "_blank")}">Contact Us</button>
				</bs-form-item>
				<bs-switch
					id="cycle-switch"
					size="tiny"
					.checked="${colorMode !== "light"}"
					@update="${(e: CustomEvent<boolean>) => setColorMode(e.detail ? "dark" : "light")}"
				>
					<bs-text class="${classMap({ "color-mode-emoji": true, active: colorMode === "light" })}" slot="before"
						>☀️</bs-text
					>
					<bs-text class="${classMap({ "color-mode-emoji": true, active: colorMode !== "light" })}">🌙</bs-text>
				</bs-switch>
			</div>
		`;
	}
}
